import sdl from '@jds/react-generated-sdl/JDSFABInternal';
import type { JDSFABInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSFABInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    show = true,
    extend = true,
    ariaLabel = props.title?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { show, extend, ariaLabel, ...rest },
    'JDSFABInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const FABInternal = withLogic(Component) as React.FC<JDSFABInternalProps> & {
  slotName?: string;
};

FABInternal.displayName = 'FABInternal';
FABInternal.slotName = 'jdsfab_internal';

export { FABInternal, type JDSFABInternalProps };
